module.exports = __webpack_public_path__ + "img/sHolyGoat_193x205.5a392c20.png";